import { MapContainer } from "./map-styles";

const MapGoogle = () => {
  return (
    <MapContainer>
      <div className="map-responsive">
        <iframe
          title="Localização Soluteck Assistência Técnica"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.1767747108634!2d-48.04940542527255!3d-15.8473037242593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a332cab5d3e25%3A0x3e4337519d2e5a9!2sSoluteck%20Assist%C3%AAncia%20T%C3%A9cnica!5e0!3m2!1spt-BR!2sbr!4v1776559553785!5m2!1spt-BR!2sbr"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    </MapContainer>
  );
};

export default MapGoogle;
